module.exports = __webpack_public_path__ + "img/values.225c8193.png";